import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { playClickSound } from '../utils/sounds';

function LogoutButton() {
  const { logout } = useAuth0();

  const handleLogout = () => {
    playClickSound();

    // Clear username and username changed flag from localStorage
    localStorage.removeItem('blockRivalsUsername');
    localStorage.removeItem('blockRivalsUsernameChanged');

    // Clear session-specific names
    sessionStorage.removeItem('blockRivalsSessionPlayerName');
    sessionStorage.removeItem('blockRivalsSessionGuestName');

    // Then logout from Auth0
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <button
      onClick={handleLogout}
      className="menu-btn secondary auth-btn"
    >
      Log Out
    </button>
  );
}

export default LogoutButton;
